import {
  Inbox, ShieldCheck, ClipboardCheck, PackageCheck, Truck, BadgeDollarSign, Bell,
} from "lucide-react";import LuxSidebar from "./LuxSidebar";
import { useUnread } from "@/lib/useUnread";

const NAV = [
  { section: "Queue",      to: "/pharmacy/orders",         label: "Assigned Orders",           icon: Inbox,          tid: "pharm-nav-orders" },
  { section: "Queue",      to: "/pharmacy/verification",   label: "Prescription Verification", icon: ShieldCheck,    tid: "pharm-nav-verification" },
  { section: "Fulfilment", to: "/pharmacy/dispense",       label: "Stock & Quote",             icon: ClipboardCheck, tid: "pharm-nav-dispense" },
  { section: "Fulfilment", to: "/pharmacy/fulfilment",     label: "Fulfilment",                icon: PackageCheck,   tid: "pharm-nav-fulfilment" },
  { section: "Fulfilment", to: "/pharmacy/delivery",       label: "Delivery Status",           icon: Truck,          tid: "pharm-nav-delivery" },
  { section: "Finance",    to: "/pharmacy/settlements",    label: "Settlements",               icon: BadgeDollarSign, tid: "pharm-nav-settlements" },
  { section: "Console",    to: "/partner/account",         label: "My Business",               icon: ShieldCheck,    tid: "pharm-nav-account" },
  { section: "Console",    to: "/partner/notifications",   label: "Alert Preferences",         icon: Bell,           tid: "pharm-nav-alerts" },
];

export default function PharmacyNav() {
  const { partner_total } = useUnread();
  // Badge counts unread GUEST MESSAGES, not orders — hint says so on hover.
  const items = NAV.map((n) =>
    n.to === "/pharmacy/orders"
      ? { ...n, badge: partner_total, badgeTitle: "Unread guest messages" }
      : n);
  return <LuxSidebar items={items} subtitle="Partner Console" footer="Assigned orders only · no clinical edits"
    testidPrefix="pharm-nav" homePath="/pharmacy/orders" />;
}
